import Vue from 'vue'

// setar prefixo em url [parametro 'prefixo da url']
Vue.filter('urlPrefix', function(url, prefix){
      return prefix + url
})


Vue.filter('uppercase', function (value) {
	return value.toUpperCase()
})

Vue.filter('statusPagamento', function (value) {
    switch (value) {
      case 'Aberto':
        return 'text-success'
        break;
      case 'Pago':
        return 'text-primary'
        break;
      case 'Cancelado':
        return 'text-danger'
        break;
      case 'Boleto Gerado':
        return 'text-warning'
        break;
      default:
        ''
    }
})

Vue.filter('textTipoPag', function (value) {
    switch (value) {
      case 'boleto':
        return 'Boleto'
        break;
      case 'debito':
        return 'Débito'
        break;
      case 'credito':
      case 'assinatura':
        return 'Crédito'
        break;
      default:
        ''
    }
})

Vue.filter('removeUnderlineText', function (value) {
  return  value.replace(/_/g, " ")
})



// WEBPACK FOOTER //
// ./resources/assets/js/filters/text.js